import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { PlaceDialog } from 'src/modules/supply_chain/components/PlaceDialog'
import { skuit } from 'src/services/skuit'

import { PlaceListTable } from 'src/components/Table/list/Place'
import { ListPage } from 'src/components/Pages/ListPage'

export const PlaceListPage = () => {
  const paginator = useQueryPaginator(
    'place-list',
    skuit.sc.places.list
  )

  const exportFields = [
    "facility_guid",
    "facility_name",
    "guid",
    "is_active",
    "name",
    "path",
    "place_type",
  ]

  return (
    <ListPage
      title='Places'
      paginator={paginator}
      dialogs={[{ title: 'New Place', Dialog: PlaceDialog }]}
    >
      <PlaceListTable
        paginator={paginator}
        fields={['name', 'facility', 'path']}
        bulkActions={['printPlace']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.places.export
        }}
      />
    </ListPage>
  )
}
